import {UserRole} from "@/shared/enums/UserRolesEnums";
import AnalyticsDefaultView from "@/views/App/Analytics/AnalyticsDefaultView.vue";
import routesAnalyticsAccounting from "./Accounting";
import routesAnalyticsUnemployed from "./Unemployed";
import routesAnalyticsCoach from "./Coach";
import routesAnalyticsFinishedCoaching from "@/router/Analytics/FinishedCoaching";
import routesAnalyticsActiveCoachingHistory from "@/router/Analytics/ActiveCoachingHistory";
import Analytics from "@/views/App/Analytics/Analytics.vue";
import routesAnalyticsUnitsDoneByExternalCoaches from "@/router/Analytics/UnitsDoneByExternalCoaches";
import routesAnalyticsBillingForecast from "@/router/Analytics/BillingForecast";
import routesAnalyticsMonthlyList from "@/router/Analytics/MonthlyList";
import routesAnalyticsRetrospective from "@/router/Analytics/Retrospective";
import routesAnalyticsTerminatedCoaching from "@/router/Analytics/TerminatedCoaching";


const routesAnalytics = [
    {
        path: "analytics",
        name: "analytics",
        component: AnalyticsDefaultView,
        children: [
            {
                path: "",
                name: "analyticsHome",
                component: Analytics,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
            },
            ...routesAnalyticsUnemployed,
            ...routesAnalyticsCoach,
            ...routesAnalyticsAccounting,
            ...routesAnalyticsBillingForecast,
            ...routesAnalyticsFinishedCoaching,
            ...routesAnalyticsUnitsDoneByExternalCoaches
        ],
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
                UserRole.COACH,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "/analytics/billing_forecast/",
        name: "analyticsBillingForecast",
        component: AnalyticsDefaultView,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
                UserRole.COACH,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "/analytics/active-coaching-history/",
        name: "analyticsActiveCoachingHistory",
        component: AnalyticsDefaultView,
        children: routesAnalyticsActiveCoachingHistory,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
                UserRole.COACH,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "/analytics/monthly-list/",
        name: "analyticsMonthlyList",
        component: AnalyticsDefaultView,
        children: routesAnalyticsMonthlyList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ASSISTANT_VQ,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "/analytics/retrospective/",
        name: "analyticsRetrospective",
        component: AnalyticsDefaultView,
        children: routesAnalyticsRetrospective,
        meta: {
            roles: [
                UserRole.ADMIN,
            ]
        },
    },
    {
        path: "/analytics/terminated-coaching/",
        name: "analyticsTerminatedCoaching",
        component: AnalyticsDefaultView,
        children: routesAnalyticsTerminatedCoaching,
        meta: {
            roles: [
                UserRole.COACH,
            ]
        },
    },
]

export default routesAnalytics;